import { createContext, useContext } from 'react';
import { QueryCache } from  '@tanstack/react-query';

type QueryStatusProviderValue = any;

export const QueryStatusContext = createContext<
  QueryStatusProviderValue | undefined
>(undefined);

export const useQueryIsLoading = (key: string) => {
  const context = useContext(QueryStatusContext);

  if (context === undefined) {
    throw new Error(
      'useQueryIsLoading must be used within a QueryStatusProvider',
    );
  }
  return Object.keys(context)
    .filter((q) => q.includes(key))
    .some((key) => context[key] === 'loading');
};
